import React from "react";

import { graphql } from "gatsby";

import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  Container,
  Content,
  Description,
  TemplateIframe,
  TemplateIframeContainer,
} from "./PreviewTemplateBlock.styles";

export interface PreviewTemplateBlockProps
  extends Queries.SanityPreviewTemplateBlock {}

const PreviewTemplateBlock: React.FC<PreviewTemplateBlockProps> = ({
  headline,
  _rawDescription,
  templateTitle,
  templateId,
}) => (
  <Container>
    <Content>
      <Text variant="H3" as="h3">
        {headline}
      </Text>
      <Description>
        <RichText text={_rawDescription} />
      </Description>
      <TemplateIframeContainer>
        <TemplateIframe
          height="687"
          src={`https://app.uizard.io/templates/${templateId}/embed`}
          allowFullScreen
          title={`${templateTitle}`}
        />
      </TemplateIframeContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment PreviewTemplateBlock on SanityPreviewTemplateBlock {
    _key
    _type
    headline
    _rawDescription(resolveReferences: { maxDepth: 5 })
    templateTitle
    templateId
  }
`;

export default PreviewTemplateBlock;
